import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllSubscription } from '../../store/actions/new/subscriptionListAction';
import { ShimmerCategoryItem } from 'react-shimmer-effects';

const SubscriptionList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    const { subscriptionData } = useSelector((store) => store);
    const { data, isLoading } = subscriptionData;
    const dispatch = useDispatch();
    
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') && 
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
         }
    };
    useEffect(() => {
        if (!data || data.length === 0) {
            dispatch(GetAllSubscription());
        }
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [dispatch, data]);
    return (
        <div className="card-container card-list-area">
            <div className="list-table connection-list">
                {!isLoading &&
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Card limit</th>
                                <th>Lead</th>
                                <th>Renewal date</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.length > 0 && data.map((item, index) => {
                                return (
                                    <tr>
                                        <td>
                                            <div className="list-profile">
                                                <span>{item.productTitle} <span className='table-badge'>{item.productRenewalIntervalUnit === "months" ? "Monthly" : "Yearly"}</span></span>
                                            </div>
                                        </td>
                                        <td>{item.cardLimit}</td>
                                        <td>{item.leadLimit}</td>
                                        <td>{item.dateTo.split(' ')[0]} {item.autoRenewal === "1" ? <span className='table-badge'>Auto</span> : ""}</td>
                                        <td align='right'>
                                            <button
                                                className="share-button icon-button list-btn dropdown-toggle-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleDropdown(index);
                                                }}
                                            >
                                                <i
                                                    className="ri-more-2-fill"
                                                ></i>
                                            </button>
                                            <div className="list-edit-dropdown">
                                                {openDropdown === index && (
                                                    <ul>
                                                        <li><a href='#'>Support</a></li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }
            </div>
        </div>
    );
}

export default SubscriptionList;
